import z from "zod";

export const BugReportSchema = z.object({
    title: z.string().min(10, "bugReport.TITLE_REQUIRED"),
    description: z.string().min(1, "bugReport.DESC_REQUIRED"),
});

export type BugReportData = z.infer<typeof BugReportSchema>;
